import hasInstoreChannel from "client/utils/hasInstoreChannel";

import { FieldError } from "../../error";
import { Field } from "../../field";
import { FieldSet } from "../../fieldset";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";
import { maxLength } from "../../validate";

export class NumberOfStoresField extends Field<number> {
  constructor(
    model: Merchant,
    fieldSet: FieldSet<any>,
    opts: Partial<MerchantField<number>> = {}
  ) {
    super(
      model,
      {
        dataType: "number",
        testValue: 10,
        propertyName: "numOfStores",
        uiFieldType: "Input",
        uiInputBaseProps: {
          inputMode: "numeric",
        },
        ...opts,
      },
      fieldSet
    );
  }
  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    const salesChannel = this._model.storeDetails.salesChannel.value;

    // base case
    if (!registeredCountry || !salesChannel) {
      return false;
    }

    if (
      registeredCountry === "Australia" ||
      registeredCountry === "New Zealand" ||
      registeredCountry === "United States"
    ) {
      if (hasInstoreChannel(salesChannel)) {
        return true;
      }
    }
    return false;
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }

  _validate(): void {
    const valueToValidate = "" + this.value;

    if (!maxLength(5)(valueToValidate)) {
      throw new FieldError(this, `Max length 5`, "InvalidLength");
    }
  }
}
